export const SUPPORTED_SUBSTRINGS = [
  // Youtube
  'youtube.com',
  'youtu.be',

  // Vimeo (TODO: debug odd vimeo videos and re-enable them)
  'vimeo.com',
];

export const UNSUPPORTED_SUBSTRINGS = [
  // Youtube
  'youtube.com/embed',
];

export default function isSupportedVirtualTourUrl(url: string): boolean {
  return (
    SUPPORTED_SUBSTRINGS.some(substring => url.includes(substring)) &&
    !UNSUPPORTED_SUBSTRINGS.some(substring => url.includes(substring))
  );
}
